import { useEffect, useState } from "react";
import { Button, CircularProgress, Grid, IconButton,Typography } from "@mui/material";
import { Save as SaveIcon, Edit as EditIcon, Delete as DeleteIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon, Add as AddIcon } from "@mui/icons-material";
import { useMutation } from "react-query";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ValidationSchemaArrayImageGallery } from "../services/SchemaValidation";
import FullScreenDialog from "components/Dialog/FullScreenDialog";
import ImageGalleryCard from "components/Card/ImageLeftCard";
import { editProductImageGallery } from "services/api/Product";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import GenerateAutomaticGallery from "domain/Media/GenerateAutomaticGallery";

export default function ImagesGallery({ open, close, instance, reportAction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [position, setPosition] = useState(null)
  const [instanceSelected, setInstanceSelected] = useState({})
  const [openGenerateAG, setOpenGenerateAG] = useState(false)
    let { /*handleSubmit: hTBP, formState: { errors: eTBP },*/ control: cTBP, setValue: svTBP, getValues } = useForm({ 
    resolver: yupResolver(ValidationSchemaArrayImageGallery), 
    defaultValues: { 'images': [] } 
  })
  const {fields: fTBP, append: aTBP, remove: rmvTBP, update: updTBP, move: mvTBP} = useFieldArray({ 
    name: 'images', control: cTBP 
  })

  useEffect(() => { if (open) { svTBP('images', instance.image_gallery) } }, [open])

  const mutation = useMutation(editProductImageGallery, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { 
        reportAction('image-gallery', false, { message: 'Error al editar los datos'}, false)
      } else { 
        reportAction('image-gallery', false, { }, true) 
      }
    }
  })

  const onSubmit = () => { //console.log("onSubmit", fTBP) 
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: fTBP })
  }

  const handleClose = () => { close(); }

  const handleAddImageGallery = (data) => { aTBP(data) }
  const handleLoadEditImageGallery = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleEditImageGallery = (data) => { 
    let dataTemp = { ...fTBP[position], image: data.image, description: data.description }
    updTBP(position, dataTemp) 
  }
  const handleLoadRemoveImageGallery = (position, data) => {
    setPosition(position)
    setInstanceSelected(data)
  }
  const handleRemoveImageGallery = () => { rmvTBP(position) }
  const handlerChangePositionImageGallery = (direction, position) => { mvTBP(position, direction === 'up' ? position - 1 : position + 1) }

  const Actions = ({ item, index, totalItems }) => ( <>
    <IconButton aria-label="edit" onClick={ () => { handleLoadEditImageGallery(index, item); setOpenAction(2) }  }> <EditIcon color="info"/> </IconButton>
    <IconButton aria-label="delete" onClick={ () => { handleLoadRemoveImageGallery(index, item); setOpenAction(3) } }> <DeleteIcon color='error'/> </IconButton>
    <div>
    {index !== 0 && <IconButton aria-label="up-position" onClick={ () => handlerChangePositionImageGallery("up", index) }> <ArrowUpwardIcon /> </IconButton>}
    {index !== totalItems - 1 && <IconButton aria-label="down-position" onClick={ () => handlerChangePositionImageGallery("down", index) }> <ArrowDownwardIcon /> </IconButton> }
    </div>
  </> )

  /* Drag and Drop */
  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = getValues("images");
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    svTBP('images', updatedList)
  }

  const handlerLoadImages = (images) => {
    let imagesArray = []
    images.forEach(image => {
      const descriptionSplit = image.split("%2F")
      const descriptionSplit2 = descriptionSplit[3].split(".")

      let schemaTmp = { image: image, description: descriptionSplit2[0]}
      imagesArray.push(schemaTmp)
    })
    console.log(imagesArray)
    svTBP("images", imagesArray)
  }
 
  return ( <>
    <FullScreenDialog open={ open } changeOpen={ handleClose } title={`Galería de imagenes - ${instance.name}`} actions={ <>
      { !isLoading ? <>
        <IconButton autoFocus color="inherit" onClick={ () => setOpenAction(1) } aria-label="add"> <AddIcon /> </IconButton> 
        <IconButton autoFocus color="inherit" onClick={ onSubmit } aria-label="save"> <SaveIcon /> </IconButton>
      </> : <CircularProgress /> }
    </> }>
      <Button onClick={() => setOpenGenerateAG(true)}>Cargar imagenes dinámicamente</Button><br />
      <div className="admin-image-gallery one-columns">
        <div className="list-container">
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="droppable">
              { (provided) => (
                <Grid container spacing={2} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                { (fTBP.length > 0) ? (
                fTBP.map((item, i) => (
                  <Draggable key={item.id} draggableId={item.id} index={i}>
                    {(provided) => (
                      <Grid item xs={12} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                        <ImageGalleryCard 
                          image={item.image} 
                          description={item.description} 
                          actions={ 
                            <Actions item={ item } index={ i } totalItems={ fTBP.length }/> 
                          }
                        />
                      </Grid>
                    )}
                  </Draggable>
                )) ) : <Grid item xs={12}> <Typography variant="inherit">No hay imágenes agregadas</Typography> </Grid> }
                </Grid>
              ) }
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </FullScreenDialog>
    <Add open={ openAction === 1 } close={ () => setOpenAction(0) } rsdId={ instance._id } action={ handleAddImageGallery } />
    <Edit open={ openAction === 2 } close={ () => setOpenAction(0) } rsdId={ instance._id } instance={ instanceSelected } action={ handleEditImageGallery } />
    <Remove open={ openAction === 3 } close={ () => setOpenAction(0) } instance={ instanceSelected } action={ handleRemoveImageGallery } />
    <GenerateAutomaticGallery open={openGenerateAG} setOpen={setOpenGenerateAG} setImages={ handlerLoadImages } path={`products/${instance._id}/gallery`} />
  </> )
}